import { Editor, Node, NodeEntry } from "slate"

export function normalizeNode(editor: Editor, entry: NodeEntry<Node>): boolean {
  editor
  entry
  return false
}
